import { VColorPicker } from 'vuetify/lib/components/VColorPicker';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VLayout,{attrs:{"row":"","wrap":""}},[_c(VFlex,{attrs:{"xs12":""}},[_c('div',{class:_vm.textClass},[_vm._v(" "+_vm._s(_vm.text)+" ")]),_c(VColorPicker,{attrs:{"hide-canvas":"","hide-inputs":"","hide-mode-switch":"","show-swatches":""},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }